import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./StreamTitle.css";
import { a11yOnly } from "styles/global.css";

export default function StreamTitle(props) {
  return (
    <h2 className={classNames(styles.root, { [a11yOnly]: props.a11yOnly })}>
      {props.text}
      {props.unreadCount > 0 && " / "}
      {props.unreadCount > 0 && `${props.unreadCount > 20 ? "20+" : props.unreadCount} Unread Stor${props.unreadCount === 1 ? "y" : "ies"}`}
    </h2>
  );
}

StreamTitle.propTypes = {
  text: PropTypes.string.isRequired,
  unreadCount: PropTypes.number,
  a11yOnly: PropTypes.bool,
};
